import { render, staticRenderFns } from "./ModuleDownload.vue?vue&type=template&id=3110c78c&scoped=true&"
import script from "./ModuleDownload.vue?vue&type=script&lang=js&"
export * from "./ModuleDownload.vue?vue&type=script&lang=js&"
import style0 from "./ModuleDownload.vue?vue&type=style&index=0&id=3110c78c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3110c78c",
  null
  
)

export default component.exports